<script lang="ts">
    import { setContext } from "svelte";    
    import { get, Readable, readable } from "svelte/store";
    import { Button, Icon, ListGroup, ListGroupItem } from "sveltestrap";
    import type { FormInstance } from "../../Model/FormInstance";
    import type { FormMember } from "../../Model/FormMember";
    import type { ReadableStore } from "../../Model/ReadableStore";
    import { instancesService, notificationsService } from "../../Services";
    import UsersSelectModal from "../UsersSelectModal.svelte";
    import MembersListOwnerItem from "./MembersListOwnerItem.svelte";

    export let instance: FormInstance;

    setContext('getInstance', () => instance);

    let members: Readable<FormMember[]>;
    let isSigned: ReadableStore<boolean>;
    let isFinished: ReadableStore<boolean>;
    let openUserSelectModal = false;

    $: setupInstance(instance);

    function setupInstance(instance: FormInstance): void {
        isSigned = instance.isSignedReadable;
        isFinished = instance.isFinishedReadable;
        members = readable([], set => instance.membersReadable.subscribe((members: FormMember[]) => {
            //Colocamos al propietario en la primera posición del array
            const sorted = [
                members.find(({ isOwner }) => isOwner),
                ...members.filter(({ isOwner }) => !isOwner),
            ];
            set(sorted);
        }));
    }
   
    function toggleUserSelectModal(): void {
        openUserSelectModal = !openUserSelectModal;
        setupInstance(instance);
    }

    async function removeSignatures(): Promise<void> {
        if (!confirm('¿Sguro que desea eliminar todas las firmas de este formulario?')) {
            return;
        }
        try {
            await instancesService.removeSignatures(instance.id);
            instance.members.forEach(member => member.isSigned = false);
            notificationsService.success('Correcto', 'Las firmas han sido eliminadas.');
        } catch (error) {
            console.error(error);
        }
    }

</script>

<ListGroup>
    {#each $members as member}
    <ListGroupItem>
        <MembersListOwnerItem {member} />
    </ListGroupItem>
    {/each}
</ListGroup>

{#if !$isFinished}
<div class="d-flex flex-row-reverse justify-content-between">
    <Button type="button" color="success" class="mt-2" size="sm" on:click={toggleUserSelectModal}>
        <Icon name="pencil" /> Editar miembros
    </Button>
    {#if $isSigned}
    <Button type="button" color="danger" class="mt-2" size="sm" on:click={removeSignatures}>
        <Icon name="x" /> Quitar firmas
    </Button>
    {/if}
</div>
{/if}

<UsersSelectModal
    {instance}
    isOpen={openUserSelectModal}
    toggle={toggleUserSelectModal}></UsersSelectModal>
